import { render, staticRenderFns } from "./MinionTable.vue?vue&type=template&id=da6d49ac&"
import script from "./MinionTable.vue?vue&type=script&lang=js&"
export * from "./MinionTable.vue?vue&type=script&lang=js&"
import style0 from "./MinionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports